import React, { useCallback, useEffect, useRef, useState } from "react";
import { Field } from "redux-form";
import { useSelector } from "react-redux";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { ContentState, EditorState, convertToRaw } from "draft-js";

import emailEditor from "../../../../../../../common/EmailEditor";
import styles from "./DynamicSwmsContentManagementSection.module.css";

export default function DynamicSwmsContentManagementSection({ sectionKey, sectionData, loading, change }) {
  const descriptionFieldName = `sections.${sectionKey}.data.description`;

  const getNestedValue = (obj, path) =>
    path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);

  const descriptionValue = useSelector((state) => {
    const formState = state && state.form && state.form.job_swms_form_v3 ? state.form.job_swms_form_v3 : {};
    return getNestedValue(formState.values, descriptionFieldName) || getNestedValue(formState.initial, descriptionFieldName) || "";
  });

  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const lastEditorHtmlRef = useRef("");

  const getEditorStateFromHtml = useCallback((html = "") => {
    const blocksFromHtml = htmlToDraft(html);
    if (blocksFromHtml && blocksFromHtml.contentBlocks) {
      const contentState = ContentState.createFromBlockArray(blocksFromHtml.contentBlocks);
      return EditorState.createWithContent(contentState);
    }

    return EditorState.createEmpty();
  }, []);

  useEffect(() => {
    if ((descriptionValue || "") === lastEditorHtmlRef.current) {
      return;
    }

    setEditorState(getEditorStateFromHtml(descriptionValue || ""));
  }, [descriptionValue, getEditorStateFromHtml]);

  const onEditorStateChange = useCallback((newState) => {
    setEditorState(newState);
    if (change) {
      const html = draftToHtml(convertToRaw(newState.getCurrentContent()));
      lastEditorHtmlRef.current = html;
      change(descriptionFieldName, html);
    }
  }, [change, descriptionFieldName]);

  return (
    <div className={styles.SectionWrap}>
       <div className="swmsv2-custom-draft-editor">
        <Field
          name={descriptionFieldName}
          component={emailEditor}
          editorState={editorState}
          onEditorStateChange={onEditorStateChange}
          disabled={loading}
        />
      </div>

      {loading ? <div className={styles.DisabledHint}>Loading section data...</div> : null}
    </div>
  );
}
